<template>
  <button
    class="border-custom filter-button"
    style="padding: 0.125rem"
    :class="{
      active: active
    }"
    @click="$emit('click')"
  >
    <div
      class="border-custom lock w-full h-full flex flex-col justify-center border-interaction-light"
      style="padding-bottom: 0.0625rem; border-radius: 0.2rem;"
    >
      <slot></slot>
    </div>
  </button>
</template>
<script>
export default {
  name: "FilterButton",
  components: {},
  props: {
    active: {
      type: Boolean
    }
  }
};
</script>

<style scoped>
.border-custom {
  border-width: 0.125rem;
  border-radius: 0.25rem;
  border-color: var(--interaction-light);
}

@media (min-width: 1024px) {
  .border-custom {
    border-width: 2px;
  }
}

.filter-button {
  width: 6rem;
  flex: 1 1 6rem;
  color: var(--interaction-dark);
  margin: 0 0.05rem;
}

@media (min-width: 1024px) {
  .filter-button {
    width: 8rem;
    flex: 0 1 8rem;
  }
}

.filter-button.active {
  background-color: var(--interaction-light);
  color: var(--color-regular);
  font-weight: bold;
}
</style>
